import { type AnyAction } from 'redux';
import { put, call, takeLatest, type CallEffect, type PutEffect, type ForkEffect } from 'redux-saga/effects';
import { HolidayActionType } from './enums';
import { addHolidays, deleteHolidays, fetchHolidays, updateHolidays } from './api';

type UserSagaEffect = Generator<CallEffect<any> | PutEffect<any>>;
type UserSagaForEffect = Generator<ForkEffect<void>>;

export function* fetchHolidaysEffect(action: AnyAction): UserSagaEffect {
	const { errorCB } = action.payload;
	try {
		const { data }: any = yield call(fetchHolidays);
		yield put({
			type: HolidayActionType.STORE_HOLIDAYS,
			payload: data
		});
	} catch (error) {
		if (errorCB) errorCB();
		yield put({
			type: HolidayActionType.ERROR_HOLIDAYS,
			payload: {
				error
			}
		});
	}
}

export function* addHolidayEffect(action: AnyAction): UserSagaEffect {
	try {
		const { successCB, formData } = action.payload;
		yield call(addHolidays, { ...formData });
		successCB();
	} catch (error) {
		yield put({
			type: HolidayActionType.ERROR_HOLIDAYS,
			payload: {
				error
			}
		});
	}
}

export function* deleteHolidayEffect(action: AnyAction): UserSagaEffect {
	const { successCB, date, errorCB } = action.payload;
	try {
		yield call(deleteHolidays, date);
		successCB();
	} catch (error) {
		errorCB(error);
	}
}

export function* updateHolidayEffect(action: AnyAction): UserSagaEffect {
	const { successCB, holiday, errorCB } = action.payload;
	try {
		yield call(updateHolidays, { ...holiday });
		successCB();
	} catch (error) {
		errorCB(error);
	}
}

export function* fetchHolidaysSaga(): UserSagaForEffect {
	yield takeLatest(HolidayActionType.FETCH_HOLIDAYS, fetchHolidaysEffect);
}

export function* addHolidaySaga(): UserSagaForEffect {
	yield takeLatest(HolidayActionType.ADD_HOLIDAY, addHolidayEffect);
}

export function* deleteHolidaySaga(): UserSagaForEffect {
	yield takeLatest(HolidayActionType.DELETE_HOLIDAY, deleteHolidayEffect);
}

export function* updateHolidaySaga(): UserSagaForEffect {
	yield takeLatest(HolidayActionType.UPDATE_HOLIDAY, updateHolidayEffect);
}
